import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fzhauptklasse-list-view',
  imports: [],
  templateUrl: './fzhauptklasse.list-view.html',
  styleUrls: ['./fzhauptklasse.list-view.css'],
})
export class FzhauptklasseListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
